// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".saoPrice[data-v-3af7826d] {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 0.2rem;\n}\n.saoPrice .p2[data-v-3af7826d] {\n    font-size: 0.1rem;\n}\n.saoPrice .p2 span[data-v-3af7826d] {\n      color: #3571f6;\n}\n", ""]);
// Exports
module.exports = exports;
